/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route__routemarkers__arialabel__discovery1 = /** @type {(inputs: {}) => string} */ () => {
	return `marker auf der Entdeckungsroute`
};

const en_route__routemarkers__arialabel__discovery1 = /** @type {(inputs: {}) => string} */ () => {
	return `marker on the discovery route`
};

const es_route__routemarkers__arialabel__discovery1 = /** @type {(inputs: {}) => string} */ () => {
	return `marcador en la ruta de descubrimiento`
};

const fr_route__routemarkers__arialabel__discovery1 = /** @type {(inputs: {}) => string} */ () => {
	return `marqueur sur l'itinéraire découverte`
};

const it_route__routemarkers__arialabel__discovery1 = /** @type {(inputs: {}) => string} */ () => {
	return `marcatore sul percorso di scoperta`
};

const nl_route__routemarkers__arialabel__discovery1 = /** @type {(inputs: {}) => string} */ () => {
	return `markering op de ontdekkingsroute`
};

const pt_route__routemarkers__arialabel__discovery1 = /** @type {(inputs: {}) => string} */ () => {
	return `marcador na rota de descoberta`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const route__routemarkers__arialabel__discovery1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route__routemarkers__arialabel__discovery1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route__routemarkers__arialabel__discovery1", locale)
	if (locale === "de") return de_route__routemarkers__arialabel__discovery1(inputs)
	if (locale === "en") return en_route__routemarkers__arialabel__discovery1(inputs)
	if (locale === "es") return es_route__routemarkers__arialabel__discovery1(inputs)
	if (locale === "fr") return fr_route__routemarkers__arialabel__discovery1(inputs)
	if (locale === "it") return it_route__routemarkers__arialabel__discovery1(inputs)
	if (locale === "nl") return nl_route__routemarkers__arialabel__discovery1(inputs)
	return pt_route__routemarkers__arialabel__discovery1(inputs)
};
export { route__routemarkers__arialabel__discovery1 as "route__routemarkers__ariaLabel__discovery" }